import React from 'react'
import WilliamBranhamWelcome from './sections/WilliamBranhamWelcome/WilliamBranhamWelcome'
import WilliamBranhamLinks from './sections/WilliamBranhamLinks/WilliamBranhamLinks'
import WilliamBranhamFirst from './sections/WilliamBranhamFirst/WilliamBranhamFirst'
import WilliamBranhamSecond from './sections/WilliamBranhamSecond/WilliamBranhamSecond'
import WilliamBranhamThird from './sections/WilliamBranhamThird/WilliamBranhamThird'
import WilliamBranhamFourth from './sections/WilliamBranhamFourth/WilliamBranhamFourth'

const WilliamBranham = () => {
  return (
    <>
      <WilliamBranhamWelcome/>
      <section id='prophet'>
        <WilliamBranhamLinks/>
        <WilliamBranhamFirst/>
      </section>
      <WilliamBranhamSecond/>
      <WilliamBranhamThird/>
    </>
  )
}

export default WilliamBranham
